import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    ym: (...args: unknown[]) => void;
  }
}

const YANDEX_METRIKA_ID = 98003975;

/**
 * Хук для отслеживания навигации в Яндекс Метрике
 * Отправляет событие 'hit' при каждом изменении URL в SPA
 */
export const useYandexMetric = () => {
  const location = useLocation();

  useEffect(() => {
    // Проверяем, что ym загружен
    if (typeof window !== 'undefined' && typeof window.ym === 'function') {
      window.ym(YANDEX_METRIKA_ID, 'hit', location.pathname + location.search);
    }
  }, [location.pathname, location.search]);
};